<script>
export default {
  name: 'ElementAside',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <li>
    <router-link
        :to="{ name: url }"
        class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100 group"
    >
      <i :class="icon"></i>
      <span class="ml-3">
        {{ label }}
      </span>
    </router-link>
  </li>
</template>

<style>
.router-link-exact-active {
  @apply text-primary-800 !important
}
</style>